export default __webpack_public_path__ + "static/media/mode_dry.76f7b814.svg";